import { render, staticRenderFns } from "./MessageSendIndex.vue?vue&type=template&id=05787368&scoped=true"
import script from "./MessageSendIndex.vue?vue&type=script&lang=js"
export * from "./MessageSendIndex.vue?vue&type=script&lang=js"
import style0 from "./MessageSendIndex.vue?vue&type=style&index=0&id=05787368&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05787368",
  null
  
)

export default component.exports